import { createReducer, on } from '@ngrx/store'
import { LayoutActions } from './layout.actions'

export const isMobileReducer = createReducer(
	{ matches: false, breakpoints: {} },
	on(LayoutActions.changeLayout, (state, action) => {
		return { ...state, matches: action.breakpointState.matches }
	})
)
